import { render, staticRenderFns } from "./driver-review.vue?vue&type=template&id=27933a54&scoped=true"
import script from "./driver-review.vue?vue&type=script&lang=js"
export * from "./driver-review.vue?vue&type=script&lang=js"
import style0 from "./driver-review.vue?vue&type=style&index=0&id=27933a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27933a54",
  null
  
)

export default component.exports